<template>

  <section class="section  section--contacts  mt-5">
    <div class="container-lg">
      <div class="row">

        <div class="col-lg-6">
          <h1 class="section__title  section__title--lg">
            {{ in18['page_contact_us_title'] }}
          </h1>
          <div class="section__text">
            <p>{{ in18['page_contact_us_description'] }}</p>
          </div>
          <ul class="contacts-list">
            <li class="contacts-list__item">
              <img alt="Envelope icon" class="contacts-list__icon" src="/shop/images/envelope-icon.svg">
              <a :href="'mailto:' + in18['page_info_email']" class="link" :title="in18['page_info_email']">
                {{ in18['page_info_email'] }}
              </a>
            </li>
            <li class="contacts-list__item">
              <img alt="Clock icon" class="contacts-list__icon" src="/shop/images/clock-icon.svg">
              {{ in18['page_work_hours'] }}
            </li>
            <li class="contacts-list__item">
              <img alt="Phone icon" class="contacts-list__icon" src="/shop/images/phone-icon.svg">
              <div>
                <a :href="'tel:' + in18['page_phone_1']" class="link" :title="in18['page_phone_1']">
                  {{ in18['page_phone_1'] }}
                </a>
              </div>
              <div>
                <a :href="'tel:' + in18['page_phone_2']" class="link" :title="in18['page_phone_2']">
                  {{ in18['page_phone_2'] }}
                </a>
              </div>
            </li>
            <li class="contacts-list__item">
              <img alt="Location icon" class="contacts-list__icon" src="/shop/images/location-icon.svg">
              {{ in18['page_actual_address'] }}
            </li>
          </ul>
          <hr>
          <address class="address">
            <h3 class="address__title">{{ in18['page_company'] }}</h3>
            <p>{{ in18['page_legal_address_label'] }} <b>{{ in18['page_legal_address'] }}</b></p>
            <p>{{ in18['page_actual_address_label'] }} <b>{{ in18['page_actual_address'] }}</b></p>
            <p>{{ in18['page_pvn_label'] }} <b>{{ in18['page_pvn'] }}</b></p>
            <p>{{ in18['page_bank_label'] }} <b>{{ in18['page_bank'] }}</b></p>
            <p>{{ in18['page_iban_label'] }} <b>{{ in18['page_iban'] }}</b></p>
          </address>
        </div>

        <div class="col-lg-6">
          <form class="form  form--contacts" @submit.prevent="submitForm">

            <div class="form__group  form__group--md">
              <input
                  id="contact_name"
                  v-model="contact.name"
                  class="form-control"
                  name="contact_name"
                  type="text"
              >
              <label class="form-label" for="contact_name">
                {{ in18['page_first_name_label'] }}
                <validation-error :errors="errors['name']"></validation-error>
              </label>
              <svg class="form-control-icon">
                <use href="#form-user"></use>
              </svg>
            </div><!-- Name -->

            <div class="form__group  form__group--md">
              <input
                  id="contact_email"
                  v-model="contact.email"
                  class="form-control"
                  name="contact_email"
                  type="email"
              >
              <label class="form-label" for="contact_email">
                {{ in18['page_email_label'] }}
                <validation-error :errors="errors['email']"></validation-error>
              </label>
              <svg class="form-control-icon">
                <use href="#form-email"></use>
              </svg>
            </div><!-- Email -->

            <div class="form__group">
              <textarea
                  v-model="contact.message"
                  class="form-control  form-control--textarea  form-control--textarea-icon"
                  name="contacts_message"
              ></textarea>
              <label class="form-label" for="contacts_message">
                {{ in18['page_message_label'] }}
                <validation-error :errors="errors['message']"></validation-error>
              </label>
              <svg class="form-control-icon">
                <use href="#form-message"></use>
              </svg>
            </div><!-- Message -->

            <google-recaptcha-v3
                id="contact"
                ref="captcha"
                v-model="contact.gRecaptchaResponse"
                :site-key="captcha_site_key"
                action="contact_action"
                corner
            />
            <validation-error :errors="errors['gRecaptchaResponse']"></validation-error>

            <button class="btn  btn--green  btn--block  btn--md" type="submit">
              {{ in18['page_send_form'] }}
            </button>
          </form>
        </div>
      </div><!-- /.row -->
    </div><!-- /.container -->
  </section>


  <div class="section">
    <div class="container-lg">
      <div class="row">

        <div v-for="member in teamMembers" class="col-lg-4 col-sm-6">
          <div class="member">
            <div class="member__photo">
              <img :alt="in18['page_member_name_1'] || member.name" :src="member.image.webp">
            </div>
            <div class="member__name">
              {{ member.name }}
            </div>

            <a v-if="member.isShowEmail" :href="'mailto:'+member.email" :title="member.email"
               class="link  link--icon  link--dark">
              <img alt="Envelope icon" class=shop src="/shop/images/envelope-icon.svg" width="20">
              <span :style="{ 'margin-left': '5px' }" class="link">
                {{ member.email }}
              </span>
            </a>
            <a v-else class="link  link--icon  link--dark" @click="toggleIsShowEmail(member.id)" :title="member.email">
              <img alt="Envelope icon" class=shop src="/shop/images/envelope-icon.svg" width="20">
              <span :style="{ 'margin-left': '5px' }" class="link">
                {{ in18['page_show_email'] }}
              </span>
            </a>
            <div class="member__text">
              {{ showDescription(member) }}
              <a v-if="isShowReadMore(member.description)"
                 class="link  link--blue  fw-500"
                 @click="toggleIsShowFullDescription(member.id)">
                {{ member.isShowFullDescription ? in18['page_read_less'] : in18['page_read_all'] }}
              </a>
            </div>
          </div>
        </div>

      </div><!-- /.row -->
    </div><!-- /.container -->
  </div><!-- /.section -->

</template>

<script>

import {nextTick} from 'vue';
import ValidationError from '../features/ValidationError.vue';

export default {
  name:       "Contact",
  components: {
    ValidationError,
  },
  props:      {
    in18:             {
      type: Object
    },
    captcha_site_key: {
      type: String
    }
  },
  data() {
    return {
      inProgress:  false,
      errors:      [],
      contact:     {
        gRecaptchaResponse: null,
        name:               null,
        email:              null,
        message:            null
      },
      teamMembers: [],
      recaptchaLoaded: false,
    };
  },
  mounted() {
    this.initRecaptcha();
    this.fetchTeamMembers();
  },
  methods: {

    initRecaptcha() {
      if (!this.recaptchaLoaded) {
        this.$refs.captcha.init();
        this.recaptchaLoaded = true;
      }
    },

    submitForm() {

      if (this.inProgress) {
        return;
      }

      this.inProgress = true;

      axios.post('/api/page/contact', this.contact)
          .then((response) => {
            window.toastr.success(response.data.message);
            this.errors = [];
            this.contact = {
              gRecaptchaResponse: null,
              name:               null,
              email:              null,
              message:            null
            };
          })
          .catch((error) => {
            window.toastr.error(error.response.data.message);
            this.errors = error.response.data.errors;
            nextTick(() => {
              window.scrollToErrorMessage()
            });
          })
          .finally(() => {
            this.inProgress = false;
            this.$refs.captcha.execute();
          });
    },

    fetchTeamMembers() {

      // Show loading indicator.
      this.isLoading = true;

      axios
          .get("/api/team-members")
          .then((response) => {
            this.teamMembers = response.data.teamMembers.map(el => {
              el.isShowEmail = false;
              el.isShowFullDescription = false;
              return el;
            });
          })
          .catch((error) => {
            console.error(error.response);
            window.toastr.error(error.response.data.message);
          })
          .finally(() => {
            // Hide loading indicator.
            this.isLoading = false;
          });
    },
    toggleIsShowEmail(id) {
      this.teamMembers.map(el => {
        el.isShowEmail = el.id === id ? !el.isShowEmail : el.isShowEmail;
        return el;
      });
    },
    toggleIsShowFullDescription(id) {
      this.teamMembers.map(el => {
        el.isShowFullDescription = el.id === id ? !el.isShowFullDescription : el.isShowFullDescription;
        return el;
      });
    },
    isShowReadMore: (description) => description.length > 150,
    showDescription(member) {
      if (member.short_description) {
        return member.isShowFullDescription
            ? member.description
            : member.short_description;
      }
      return '';
    },
  },
}
</script>
